export const NewArrivalMagazineSearchType = {
  All: '1',
  Published: '2',
  NotPublished: '3'
}
export type NewArrivalMagazineSearchType = typeof NewArrivalMagazineSearchType[keyof typeof NewArrivalMagazineSearchType]
